module.exports = __webpack_public_path__ + "static/media/greenhouse2Step6-2.5cb1b612.jpg";